import React from 'react'
import Skeleton from "react-loading-skeleton";

const InsuranceSkeletonLoader = () => {
  return (
  
<div className="row">
  {Array.from({ length: 8 }).map((_, index) => (
    <div className="col-lg-3 col-12 mb-4" key={index}>
      <div
        className="p-3 d-flex flex-column"
        style={{
          border: "1px solid #ddd",
          borderRadius: "12px",
          backgroundColor: "#f9f9f9",
          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header Section */}
        <div className="d-flex align-items-start">
          {/* Round Image Skeleton */}
          <Skeleton
            variant="circular"
            width={50}
            height={50}
            style={{ marginRight: "16px" }}
          />
          {/* Text Placeholder */}
          <div style={{ width: "100%" }}>
            <Skeleton height={20} width={`70%`} style={{ borderRadius: "4px" }} />
          </div>
        </div>

        {/* Body Section */}
        <div className="mt-3">
          <Skeleton height={15} width={`90%`} style={{ marginBottom: "8px", borderRadius: "4px" }} />
          <Skeleton height={15} width={`85%`} style={{ marginBottom: "8px", borderRadius: "4px" }} />
        </div>

        {/* Footer Section */}
      
      </div>
    </div>
  ))}
</div>


     
  )
}

export default InsuranceSkeletonLoader